import { SelectChangeEvent } from '@mui/material';
import { GridFilterItem } from '@mui/x-data-grid';
import { FC } from 'react';

import { StateOrProvinceSelect } from './StateOrProvinceSelect';

type Props = {
	item: GridFilterItem;
	applyValue: (value: GridFilterItem) => void;
};

export const StateOrProvinceFilter: FC<Props> = ({ item, applyValue }) => {
	const onChange = (event: SelectChangeEvent) => {
		applyValue({
			...item,
			value: event.target.value,
		});
	};

	return (
		<StateOrProvinceSelect
			sx={{
				height: '100%',
				paddingTop: '16px',
			}}
			defaultValue={item.value || null}
			onChange={onChange}
		/>
	);
};
